import { render, staticRenderFns } from "./ModalMaterialsUpload.vue?vue&type=template&id=ad880bd0&"
import script from "./ModalMaterialsUpload.vue?vue&type=script&lang=js&"
export * from "./ModalMaterialsUpload.vue?vue&type=script&lang=js&"
import style0 from "./ModalMaterialsUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports